module.exports = __webpack_public_path__ + "fonts/GTAmericaMono-Regular.1eb9484c.woff2";